/**
 * Per-review overall score (API `rate`), not property-wide `avgLihe`.
 */
export function getOverallReviewRatingValue(review) {
	if (!review || typeof review !== 'object') return null
	const v = review.rate ?? review.overallRating ?? review.avgLihe
	if (v == null || v === '') return null
	const n = Number(v)
	return Number.isFinite(n) ? n : null
}
